import React from 'react'
import bannerBg from '../../assets/img/pricing-cta-bg.jpg';

const ServicesCta = () => {
  return (
    <section className="pricing-cta-wrapper text-white bg-cover bg-center section-padding" style={{backgroundImage: `url(${bannerBg})`}}>
        <div className="container">
            <div className="row">
            <div className="col-12 text-center col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 ps-xl-0 pe-xl-0">
                <div className="pricing-contents">
                <h1>Technical Services in Dubai</h1>
                <h2 className="mt-3 mb-4">Civil & MEP | AMC | Painting | Fitouts | AC Solutions</h2>
                <div className="btn-wrapper d-flex align-items-end justify-content-center flex-wrap gap-3">
                    <a href="/contact" className="theme-btn">Get Free Quote</a>
                    <div className="btn-cta">
                    <div className="icon">
                        <i className="flaticon-phone" />
                    </div>
                    <div className="content">
                        <span className="text-star">24/7 Dubai Support</span>
                        <h3>+971 50 2033924</h3>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    </section>
  )
}

export default ServicesCta
